/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesloading1Inputs */

const en_filesloading1 = /** @type {(inputs: Filesloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading files…`)
};

const pt_filesloading1 = /** @type {(inputs: Filesloading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar ficheiros…`)
};

/**
* | output |
* | --- |
* | "Loading files…" |
*
* @param {Filesloading1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesloading1 = /** @type {((inputs?: Filesloading1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesloading1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesloading1(inputs)
	return pt_filesloading1(inputs)
});
export { filesloading1 as "filesLoading" }